import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
 
@Injectable({
  providedIn: 'root',
})
export class MenuIdService {
  private imagePaths: { [domain: string]: { [id: number]: string } } = {
    'uaedemo-primez.insure.digital': {
      6130: 'assets/images/primez-logo.png'
    },
    'sudlife-primez.insure.digital': {
      6130: 'assets/images/primez-logo.png'
    },
    'swiftb2b.insure.digital': {
      6150: 'assets/images/swiftb2b-logo.svg'
    },
    'csr.swiftant.com': {
      6140: 'assets/images/csr-logo.png'
    },
    'kenindia-travel.insure.digital': {
      6120: 'assets/images/kenindia.png'
    },
    'uat-core-primez.insure.digital.com':{
      6130:'assets/images/Afrisurelogo.svg'
    },
    'localhost': {
      6130: 'assets/images/Afrisurelogo.svg'
    },
    'cholams-primez.insure.digital': {
      6130: 'assets/images/primez-logo.png'
    },
    'zuno-primez.insure.digital': {
      6130: 'assets/images/primez-logo.png'
    },
    'starhealth-primez.insure.digital': {
      6130: 'assets/images/primez-logo.png'
    },
    'malawi.com': {
      6050: '/assets/images/menuLogo/IAM.png',
    },
    'qa-pc-primez.insure.digital': {
      6170: 'assets/images/Afrisurelogo.svg'
    },
    'nyala-primez.insure.digital':{
      6130: 'assets/images/Afrisurelogo.svg',
    }

  }

  private welcomeMsg: { [domain:string]: string } = {
   'swiftb2b.insure.digital': "Welcome to SwiftB2B! Let's get started!",
   'csr.swiftant.com': "Welcome to CSR CAMS! Let's get started!",
   'localhost': "Welcome to Core-Insurance! Let's get started!",
   'kenindia-travel.insure.digital': "Welcome to Kenindia! Let's get started!",
   'uat-core-primez': "Welcome to Core-Insurance! Let's get started!"
  };
  
  date: any = new Date().getFullYear()
  private footerContent: { [domain: string]: string } = {
    'uat-core-primez.insure.digital.com': `Afrisure @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'uaedemo-primez.insure.digital': `PrimeZ @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'sudlife-primez.insure.digital': `PrimeZ @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'cholams-primez.insure.digital': `PrimeZ @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'zuno-primez.insure.digital': `PrimeZ @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'starhealth-primez.insure.digital': `PrimeZ @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'localhost': `Afrisure @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'kenindia-travel.insure.digital' : `Kenindia @ 2023 ${'- ' + this.date} travel Insurance Version: 0.0.1 - Development`,
    'swiftb2b.insure.digital' : ` SwiftB2B @ 2024 ${'- ' + this.date} Version: 0.0.1 - Development`
  };

  private userActivateContent: { [domain: string]: string } = {
    'uat-core-primez.insure.digital.com': 'Welcome to PrimeZ',
    'uaedemo-primez.insure.digital':'Welcome to PrimeZ',
    'sudlife-primez.insure.digital': 'Welcome to PrimeZ',
    'cholams-primez.insure.digital': 'Welcome to PrimeZ',
    'zuno-primez.insure.digital': 'Welcome to PrimeZ',
    'starhealth-primez.insure.digital': 'Welcome to PrimeZ',
    'kenindia-travel.insure.digital' : 'Welcome to Kenindia',
    'swiftb2b.insure.digital' : 'Welcome to Swiftb2b'
  };

  private activeImageURLSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private activeWelcomeURLSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private activefooterURLSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private userActivateSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  orgAppID: number;
  domain: string;
 
  constructor() {
    // No HTTP request logic here
 
  }

  getOrgAppId() {
    return this.orgAppID
  }
  getImagePath(id: number, domain: string): void {
    this.orgAppID = id;
    const domainImagePaths = this.imagePaths[domain];
    if (domainImagePaths) {
      const imageURL = domainImagePaths[id];
      if (imageURL) {
        this.activeImageURLSubject.next(imageURL);
      } else {
        // Handle case where image path is not found for the given ID and domain
      }
    } else {
      // Handle case where domain is not found in imagePaths
    }
  }
  getWelcomMsg(domain: string): void{
    this.domain = domain
    const imageURL = this.welcomeMsg[domain];
    if (imageURL) {
      this.activeWelcomeURLSubject.next(imageURL);
    } else {

    }
  }
  getFooterContent(domain: string): void {
    this.domain = domain;
    const imageURL = this.footerContent[domain];
    if (imageURL) {
      this.activefooterURLSubject.next(imageURL);
    } else {

    }
  }
  getUserActivateContent(domain: string): void {
    this.domain = domain;
    const imageURL = this.userActivateContent[domain];
    if (imageURL) {
      this.userActivateSubject.next(imageURL);
    } else {

    }
  }
 
  getActiveImageURL(): Observable<string> {
    return this.activeImageURLSubject.asObservable();
  }
  getActiveWelcomeMsg(): Observable<string> {
    return this.activeWelcomeURLSubject.asObservable();
  }
  activFooterContent(): Observable<string> {
    return this.activefooterURLSubject.asObservable();
  }
  activuserContent(): Observable<string> {
    return this.userActivateSubject.asObservable();
  }
}